import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../../shared/utils';
import type { SnippetRejectionDetails } from '../../../../../shared/snippets';

import styles from './RejectedBanner.module.less';

type Props = {
  rejectionDetails: SnippetRejectionDetails;
};

/**
 * The RejectedBanner component displays a message indicating that a snippet
 * has been rejected. It includes when and by whom it was rejected.
 */
const RejectedBanner: VoidFunctionComponent<Props> = ({ rejectionDetails }) => {
  const rejectedBy = rejectionDetails.rejectedBy;
  const message = rejectionDetails.rejectedBy
    ? `Snippet rejected by ${rejectedBy} on ${prettyMDY(rejectionDetails.rejectedAt)}.`
    : `Snippet rejected on ${prettyMDY(rejectionDetails.rejectedAt)}.`;
  return (
    <div className={styles.rejectedBanner}>
      {message}
    </div>
  );
};

export default RejectedBanner;
